import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../../../services/api';

function BankAccountShow() {
    const { id } = useParams();
    const [bankAccount, setBankAccount] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadBankAccount();
    }, [id]);

    const loadBankAccount = async () => {
        try {
            const response = await api.get(`/firm_bank_accounts/${id}`);
            const account = response.data?.bank_account || response.data;
            setBankAccount(account);
        } catch (error) {
            console.error('Error loading bank account:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className="p-8 text-center">Loading...</div>;
    if (!bankAccount) return <div className="p-8 text-center">Bank account not found</div>;

    return (
        <div className="max-w-4xl mx-auto px-4 py-8">
            <div className="mb-6">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <Link to="/accounting/bank-accounts" className="p-2 text-slate-400 hover:text-blue-600 rounded-lg">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                            </svg>
                        </Link>
                        <h1 className="text-2xl font-bold text-slate-800">{bankAccount.bank_name}</h1>
                        {bankAccount.is_active && (
                            <span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-800">Active</span>
                        )}
                    </div>
                    <Link
                        to={`/accounting/bank-accounts/${id}/edit`}
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                    >
                        Edit
                    </Link>
                </div>
            </div>

            <div className="bg-white rounded-lg shadow p-6 space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label className="text-sm font-semibold text-slate-500">Account Number</label>
                        <p className="text-lg font-mono text-slate-800 mt-1">{bankAccount.account_number}</p>
                    </div>

                    <div>
                        <label className="text-sm font-semibold text-slate-500">IFSC Code</label>
                        <p className="text-lg font-mono text-slate-800 mt-1">{bankAccount.ifsc_code}</p>
                    </div>

                    {bankAccount.branch_name && (
                        <div>
                            <label className="text-sm font-semibold text-slate-500">Branch</label>
                            <p className="text-lg text-slate-800 mt-1">{bankAccount.branch_name}</p>
                        </div>
                    )}

                    {bankAccount.account_holder_name && (
                        <div>
                            <label className="text-sm font-semibold text-slate-500">Account Holder</label>
                            <p className="text-lg text-slate-800 mt-1">{bankAccount.account_holder_name}</p>
                        </div>
                    )}

                    <div>
                        <label className="text-sm font-semibold text-slate-500">Account Type</label>
                        <p className="text-lg text-slate-800 mt-1">{bankAccount.account_type}</p>
                    </div>

                    <div>
                        <label className="text-sm font-semibold text-slate-500">Opening Balance</label>
                        <p className="text-lg font-semibold text-slate-800 mt-1">
                            ₹{parseFloat(bankAccount.opening_balance || 0).toFixed(2)}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BankAccountShow;
